import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { IllustrationSpreadsheet, IllustrationPiggyBank, IllustrationLightbulb, IllustrationShield, IllustrationChecklist, IllustrationZen } from './BonusIllustrations';
const bonuses = [{
  num: 1,
  title: 'Planilla Inteligente de Control Financiero',
  desc: 'Registrá ingresos, gastos y ganancias de forma simple.',
  Illustration: IllustrationSpreadsheet
}, {
  num: 2,
  title: 'Desafío Ahorro 30 Días',
  desc: 'Creá hábitos financieros sólidos y sostenibles.',
  Illustration: IllustrationPiggyBank
}, {
  num: 3,
  title: '50 Formas Reales de Generar Ingresos Extra',
  desc: 'Ideas prácticas para aumentar tus ingresos.',
  Illustration: IllustrationLightbulb
}, {
  num: 4,
  title: 'Guía Anti Deudas',
  desc: 'Métodos simples para salir de deudas más rápido.',
  Illustration: IllustrationShield
}, {
  num: 5,
  title: 'Checklist Semanal Financiero',
  desc: 'Controlá tus números en pocos minutos por semana.',
  Illustration: IllustrationChecklist
}, {
  num: 6,
  title: 'Manual para Dejar de Vivir Preocupado por el Dinero',
  desc: 'Reducí el estrés financiero y tomá decisiones con mayor seguridad.',
  Illustration: IllustrationZen
}];
export function Bonuses() {
  return <section className="py-16 bg-navy-900 text-white relative overflow-hidden" data-id="element-19">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-800/30 skew-x-12 transform origin-top-right pointer-events-none" data-id="element-20"></div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-21">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-22">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-success/20 rounded-full mb-4" data-id="element-23">
            <Gift className="w-6 h-6 text-success" data-id="element-24" />
          </div>
          <h2 className="text-2xl md:text-4xl font-bold mb-2" data-id="element-25">
            ADEMÁS RECIBÍS 6 BONUS DE REGALO
          </h2>
          <p className="text-slate-300 text-sm md:text-base" data-id="element-26">
            Herramientas prácticas para acelerar tus resultados.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-id="element-27">
          {bonuses.map((bonus, index) => {
          const Illustration = bonus.Illustration;
          return <motion.div key={index} className="bg-navy-800 border border-navy-700 rounded-xl p-3 md:p-4 hover:border-success/50 transition-colors flex flex-col" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.35,
            delay: index * 0.06
          }} data-id="element-28">
                <div className="aspect-square w-full bg-navy-900 rounded-lg overflow-hidden mb-3 border border-navy-700" data-id="element-29">
                  <Illustration data-id="element-30" />
                </div>
                <div className="text-[10px] md:text-xs font-bold text-success mb-1 uppercase tracking-wider" data-id="element-31">
                  Bonus {bonus.num}
                </div>
                <h3 className="text-xs md:text-sm font-bold mb-1 leading-tight" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-[11px] md:text-xs text-slate-400 leading-snug" data-id="element-33">
                  {bonus.desc}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}